import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrowDown",
  "use": "icon-arrowDown-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrowDown\"><path d=\"M512 670.72L61.44 220.16 0 281.6l506.88 517.12 517.12-512-61.44-61.44L512 670.72z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol